import React, { useRef } from 'react';
import { motion, useAnimationFrame, useMotionValue, useReducedMotion, useTransform, wrap, type PanInfo } from 'framer-motion';
import type { ProjectImage } from '../data/carousels';
type ProjectCarouselProps = {
  images: ProjectImage[];
  direction?: 'left' | 'right';
  /** Seconds for one full pass of the image sequence. */
  durationSeconds?: number;
};
export function ProjectCarousel({
  images,
  direction = 'left',
  durationSeconds = 35
}: ProjectCarouselProps) {
  const trackRef = useRef<HTMLDivElement>(null);
  const isDraggingRef = useRef(false);
  const prefersReducedMotion = useReducedMotion();
  const basePercent = useMotionValue(0);
  const x = useTransform(basePercent, value => `${wrap(-50, 0, value)}%`);
  useAnimationFrame((_time, delta) => {
    if (prefersReducedMotion || isDraggingRef.current) return;
    const percentPerMs = 50 / (durationSeconds * 1000);
    const step = percentPerMs * delta * (direction === 'left' ? -1 : 1);
    basePercent.set(basePercent.get() + step);
  });
  const handlePanStart = () => {
    isDraggingRef.current = true;
  };
  const handlePan = (_event: PointerEvent, info: PanInfo) => {
    const trackWidth = trackRef.current?.offsetWidth ?? 1;
    basePercent.set(basePercent.get() + info.delta.x / trackWidth * 100);
  };
  const handlePanEnd = () => {
    isDraggingRef.current = false;
  };
  const loop = [...images, ...images];
  return <div className="relative w-full overflow-hidden" data-id="element-63" data-mp="186jy7kxizdks">
      <motion.div ref={trackRef} style={{
      x,
      touchAction: 'pan-y'
    }} onPanStart={handlePanStart} onPan={handlePan} onPanEnd={handlePanEnd} className="flex w-max cursor-grab active:cursor-grabbing" data-id="element-64" data-mp="136xjf721tp9v">
        {loop.map((image, index) => <div key={`${image.src}-${index}`} className="mr-2.5 shrink-0" style={{
        width: 'clamp(148px, 44vw, 188px)'
      }} data-id="element-65" data-mp="2tj3gynfo3yw6" data-mpi={index}>
            <img src={image.src} alt={index < images.length ? image.alt : ''} aria-hidden={index >= images.length} draggable={false} loading="lazy" decoding="async" className="aspect-square w-full select-none rounded-2xl object-cover" data-id="element-66" data-mp="2ojqyeevtxdze" />
          </div>)}
      </motion.div>
    </div>;
}